<template>
  <div>
    <v-dialog width="600px" v-model="dialog" @input="close">
      <div class="product-chooser-dialog">
        <v-form ref="form" lazy-validation v-model="isValid" @submit.prevent>
          <v-card>
            <v-card-title class="justify-center">{{
              $t("modal.whatDoYouWantToPay")
            }}</v-card-title>
            <v-card-text>
              <!-- <v-alert type="info" outlined dense>
                <v-row align="center">
                  <v-col class="grow">
                    <b
                      >Falta pagar {{ formatPrice(unpaidTotalPrice) }} de
                      {{ formatPrice(totalPriceAllOrders) }}</b
                    >
                  </v-col>
                </v-row>
              </v-alert>
              <v-row align="center">
                <v-col class="text-center pt-0">
                  <v-btn
                    style="border-radius: 50px"
                    color="primary"
                    @click="divideSelectedByOne"
                  >
                    Pagar todo
                  </v-btn>
                </v-col>
              </v-row> -->

              <TodoDivideOrProducts :dividePayment.sync="dividePayment" />

              <v-card-subtitle
                class="d-flex justify-center total-price mt-5 mb-6"
                v-if="dividePayment === 'todo'"
                >{{ $t("payment.totalToPay") }}
                {{ formatPrice(unpaidTotalPrice) }}
              </v-card-subtitle>

              <v-row
                class="pt-5 pl-md-2 pr-md-2"
                v-if="dividePayment === 'amount'"
              >
                <v-col cols="5">
                  <v-select
                    v-model="divideSelected"
                    :items="[
                      1,
                      2,
                      3,
                      4,
                      5,
                      6,
                      7,
                      8,
                      9,
                      10,
                      11,
                      12,
                      13,
                      14,
                      15,
                      16,
                      17,
                      18,
                      19,
                      20
                    ]"
                    :label="$t('modal.divide')"
                    :placeholder="$t('modal.among')"
                    outlined
                    :disabled="payAll"
                  ></v-select>
                </v-col>
                <v-col cols="7">
                  <v-text-field
                    :label="$t('modal.amountToPay')"
                    :placeholder="$t('modal.amount')"
                    v-model="amount"
                    suffix="‎€"
                    :rules="validation.amount"
                    type="number"
                    outlined
                    :disabled="payAll"
                  ></v-text-field>
                </v-col>
              </v-row>

              <!---------------------- product start ------------------------>
              <v-alert
                type="info"
                outlined
                dense
                style="font-size: 14px"
                v-if="dividePayment === 'product' && !unpaidTotalPrice"
                >{{ $t("modal.noProductsLeftToPay") }}
              </v-alert>

              <v-checkbox
                @change="onSelectAll"
                v-model="selectAll"
                :label="$t('modal.allTheProducts')"
                v-if="dividePayment === 'product' && unpaidTotalPrice"
                class="pt-5 pl-md-2 pr-md-2"
              ></v-checkbox>

              <v-divider
                v-if="dividePayment === 'product' && unpaidTotalPrice"
              />

              <div
                style="overflow-y: auto"
                class="todo-content"
                v-if="dividePayment === 'product' && unpaidTotalPrice"
              >
                <v-list>
                  <template v-for="item in orders">
                    <v-list-item
                      dense
                      v-for="(metadata, quantity) in unpaidOrders(
                        item.metadata
                      )"
                      :key="`order_${item.id}_${quantity}`"
                    >
                      <v-list-item-icon>
                        <v-checkbox
                          v-model="metadata.isSelected"
                          @change="onSelect(item, metadata, quantity)"
                          :disabled="
                            missingAmountToPay < item.price &&
                              !metadata.isSelected
                          "
                        ></v-checkbox>
                        <span class="mt-1">{{ item.name }}</span>
                      </v-list-item-icon>

                      <v-list-item-content>
                        <v-spacer />
                      </v-list-item-content>

                      <span>{{ formatPrice(getItemPrice(item)) }}</span>
                    </v-list-item>
                  </template>
                </v-list>
              </div>

              <v-card-subtitle
                class="d-flex justify-center total-price"
                v-if="dividePayment === 'product' && unpaidTotalPrice"
                >{{ $t("modal.totalSelected") }} {{ formatPrice(totalPrice) }}
              </v-card-subtitle>

              <card-or-cash-datafono
                :disabled="isDisabled"
                :mode="paymentMode"
                :paymentMode.sync="paymentMode"
                @onSelectPayment="onSelectPayment($event)"
              />
            </v-card-text>
          </v-card>
        </v-form>
        <Loader
          :dialog-loader="dialogLoader"
          :message="$t('payment.redirectingToThePaymentprocess')"
        ></Loader>

        <v-dialog v-model="dialogError" hide-overlay persistent width="400">
          <v-card>
            <v-card-title style="color: red">{{
              $t("modal.error")
            }}</v-card-title>
            <v-card-text>{{ errorMessage }}</v-card-text>
            <v-card-actions>
              <v-container>
                <v-row justify="end">
                  <v-btn text small @click="dialogError = false">{{
                    $t("modal.discard")
                  }}</v-btn>
                </v-row>
              </v-container>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </div>
    </v-dialog>
    <CashPaymentDialog ref="cashPaymentDialogRef" />
    <card-payment-dialog
      :isDisabled="isDisabled"
      @selectPaymentMethod="selectPaymentMethod($event)"
      ref="cardPaymentDialogRef"
    ></card-payment-dialog>
  </div>
</template>

<script>
import Loader from "../../common/Loader";
import TodoDivideOrProducts from "@/components/public/receipt/TodoDivideOrProducts";
import CashPaymentDialog from "@/components/public/receipt/CashPaymentDialog";
import CardOrCashDatafono from "./CardOrCashDatafono.vue";
import CardPaymentDialog from "./CardPaymentDialog.vue";
import { ordersCollection } from "@/collections/orders";

export default {
  name: "product-chooser-dialog",
  props: ["open", "unpaidTotalPrice", "totalPriceAllOrders"],
  components: {
    Loader,
    TodoDivideOrProducts,
    CashPaymentDialog,
    CardOrCashDatafono,
    CardPaymentDialog
  },
  data() {
    return {
      paymentMode: null, // 'card' or 'cash'
      isValid: false,
      dividePayment: "todo", // 'amount' or 'products'
      dialog: false,
      orders: [],
      ordersCollection: [],
      selectedPaymentMethod: null,
      dialogError: false,
      errorMessage: null,
      dialogLoader: false,
      selectAll: false,
      amount: null,
      validation: {
        amount: [
          v =>
            !v ||
            (v &&
              v >= 0.5 &&
              parseFloat(v) <= this.unpaidTotalPrice.toFixed(2)) ||
            this.$t("modal.pleaseEnterValidAmount")` ${this.formatPrice(
              this.unpaidTotalPrice
            )}`
        ]
      },
      divideSelected: 1,
      payAll: false
    };
  },
  firestore() {
    let tableQR = localStorage.getItem("tableQR");
    return {
      ordersCollection: ordersCollection
        .where("tableQR", "==", tableQR)
        .where("isOpen", "==", true)
        .orderBy("time", "desc")
    };
  },
  computed: {
    isDisabled() {
      let amount = 0;
      if (this.dividePayment === "amount") {
        return (
          !this.amount ||
          this.amount <= 0 ||
          parseFloat(this.amount) < 0.5 ||
          parseFloat(this.amount) > parseFloat(this.unpaidTotalPrice).toFixed(2)
        );
      } else if (this.dividePayment === "todo") {
        amount = this.unpaidTotalPrice;
      } else {
        amount = this.totalPrice;
      }

      return amount === 0;
    },
    totalPrice() {
      let total = 0;
      this.orders.forEach(product => {
        // eslint-disable-next-line no-unused-vars
        for (const [quantity, metadata] of Object.entries(product.metadata)) {
          if (!metadata.isPaid && metadata.isSelected) {
            total +=
              (product.quantity * product.price) /
              Object.keys(product.metadata).length;
            if (product.isMenuGroupProduct) {
              total += this.totalWithAdditionalChargeItemVice(product);
            }
          }
        }
      });
      return total;
    },
    missingAmountToPay() {
      return (this.unpaidTotalPrice - this.totalPrice).toFixed(2);
    },
    paymentMethods() {
      let paymentMethods = [
        ...this.$store.state.paymentMethods,
        { cardLast4: -1 }
      ];
      return paymentMethods.length > 1 ? paymentMethods.reverse() : [];
    }
  },
  watch: {
    open() {
      let self = this;
      this.dialog = this.open;
      if (this.dialog) {
        setTimeout(() => {
          //self.loadStripeElements();
          self.payAll = false;
          this.divideSelected = 1;
          if (this.divideSelected === 1) {
            this.amount = this.unpaidTotalPrice.toFixed(2);
            return;
          }
          this.paymentMode = null;
        }, 500);
      }
    },

    ordersCollection(orders) {
      let self = this;
      // eslint-disable-next-line no-unused-vars
      orders.forEach((pOrder, index) => {
        let order = self.orders.find(x => x.id === pOrder.id);
        if (order && order.metadata) {
          // eslint-disable-next-line no-unused-vars
          for (const [quantity, metadata] of Object.entries(order.metadata)) {
            order.metadata[quantity].isPaid = pOrder.metadata[quantity].isPaid;
          }
        }
      });
      self.setPayables();
    },
    divideSelected() {
      if (this.divideSelected === 1) {
        this.amount = this.unpaidTotalPrice.toFixed(2);
        return;
      }

      // for the division you have to take into account the total of the account,
      // instead of the total that remains to be paid
      this.amount = (this.unpaidTotalPrice / this.divideSelected).toFixed(2);
    }
  },
  mounted() {
    //this.getPaymentMethods();
    let self = this;
    let tableQR = localStorage.getItem("tableQR");

    ordersCollection
      .where("tableQR", "==", tableQR)
      .where("isOpen", "==", true)
      .orderBy("time", "desc")
      .get()
      .then(querySnapshot => {
        if (!querySnapshot.empty) {
          let orders = [];
          querySnapshot.forEach(doc => {
            orders.push(doc.data());
          });

          orders = orders.filter(x => x.metadata !== undefined);
          orders.map(order => {
            if (order.metadata) {
              // eslint-disable-next-line no-unused-vars
              for (const [quantity, metadata] of Object.entries(
                order.metadata
              )) {
                order.metadata[quantity].isSelected = false;
              }
            }
            return order;
          });

          self.orders = orders;
          self.setPayables();
        }
      })
      .catch(error => {
        // eslint-disable-next-line
        console.log("Error getting documents: ", error);
      });
  },
  methods: {
    selectPaymentMethod(event) {
      console.log(event, "selected payment mentod");
      this.selectedPaymentMethod = event;
    },
    onSelectPayment(payment) {
      this.paymentMode = payment;
      this.close();
      let amount = 0;
      if (this.dividePayment === "todo") {
        amount = this.unpaidTotalPrice;
      } else if (this.dividePayment === "amount") {
        amount = this.amount;
      } else {
        amount = this.totalPrice;
      }
      if (payment === "datafono" || payment === "cash") {
        // let amount =
        //   this.dividePayment === "amount" ? this.amount : this.totalPrice;
        let selectedProducts = [];
        if (this.dividePayment === "product") {
          // Product selection payment
          selectedProducts = JSON.parse(
            localStorage.getItem("payableProducts")
          );
        }
        this.$refs.cashPaymentDialogRef.openDialog(
          amount,
          this.dividePayment,
          selectedProducts,
          payment
        );
        this.amount = 0;
      }
      if (payment === "card") {
        let data = {
          paymentMode: payment,
          paymentMethods: this.paymentMethods,
          unpaidTotalPrice: this.unpaidTotalPrice,
          amount: amount,
          orders: this.orders,
          dividePayment: this.dividePayment,
          totalPrice: this.totalPrice
        };
        this.$refs.cardPaymentDialogRef.openDialog(data);
      }
    },
    onDivideSelected() {
      if (this.divideSelected === 1) {
        this.amount = this.unpaidTotalPrice.toFixed(2);
      }
    },
    divideSelectedByOne() {
      this.divideSelected = 1;
      this.payAll = true;
    },
    onSelectCashPayment() {
      this.close();
      let amount =
        this.dividePayment === "amount" ? this.amount : this.totalPrice;
      let selectedProducts = [];
      if (!this.dividePayment) {
        // Product selection payment
        selectedProducts = JSON.parse(localStorage.getItem("payableProducts"));
      }
      this.$refs.cashPaymentDialogRef.openDialog(
        amount,
        this.dividePayment,
        selectedProducts
      );
      this.amount = 0;
    },
    setPayables() {
      let orders = [];
      this.orders.forEach(order => {
        let shouldAdd = false;
        // eslint-disable-next-line no-unused-vars
        for (const [quantity, metadata] of Object.entries(order.metadata)) {
          if (metadata.isSelected && !metadata.isPaid) {
            shouldAdd = true;
          }
        }

        if (shouldAdd) {
          orders.push(order);
        }
      });
      localStorage.setItem("payableProducts", JSON.stringify(orders));
    },
    unpaidOrders(metadataGiven) {
      let data = {};
      for (const [quantity, metadata] of Object.entries(metadataGiven)) {
        if (!metadata.isPaid) {
          data = { ...data, [quantity]: metadata };
        }
      }
      return data;
    },
    close() {
      this.$emit("update:open", false);
      this.dialog = false;
      this.paymentMode = null;
    },
    // eslint-disable-next-line no-unused-vars
    onSelect(order, metadata, quantity) {
      let isSelectAll = true;
      this.orders.forEach(order => {
        // eslint-disable-next-line no-unused-vars
        for (const [quantity, metadata] of Object.entries(order.metadata)) {
          if (
            !order.metadata[quantity].isPaid &&
            !order.metadata[quantity].isSelected
          ) {
            isSelectAll = false;
          }
        }
      });
      this.selectAll = isSelectAll;
      this.setPayables();
    },
    onSelectAll(value) {
      let self = this;
      let total = 0;
      this.orders.map(order => {
        // eslint-disable-next-line no-unused-vars
        for (const [quantity, metadata] of Object.entries(order.metadata)) {
          total += parseFloat(order.price).toFixed(2);

          if (total <= parseFloat(self.unpaidTotalPrice).toFixed(2)) {
            order.metadata[quantity].isSelected = value;
          } else {
            total -= parseFloat(order.price).toFixed(2);
          }
        }
        return order;
      });

      this.setPayables();
    },
    getItemPrice(item) {
      if (item.isMenuGroupProduct) {
        return (
          parseFloat(item.price) + this.totalWithAdditionalChargeItemVice(item)
        );
      }
      return item.price;
    },
    totalWithAdditionalChargeItemVice(item) {
      let total = 0;
      if (item.starters) {
        item.starters.forEach(starter => {
          total += parseFloat(starter.additional_charge);
        });
      }
      if (item.maincourse) {
        item.maincourse.forEach(main => {
          total += parseFloat(main.additional_charge);
        });
      }

      if (item.desserts) {
        item.desserts.forEach(dessert => {
          total += parseFloat(dessert.additional_charge);
        });
      }

      if (item.desserts) {
        item.drinks.forEach(drink => {
          total += parseFloat(drink.additional_charge);
        });
      }
      return total;
    }
  }
};
</script>
